import { Link, Accordion, AccordionDetails, AccordionSummary, Box, Typography, List, ListSubheader, ListItem, Table, TableContainer, Paper, TableHead, TableBody, TableRow, TableCell } from '@mui/material';
import FilingSchedule from '../../../../../types/filers/fillingSchedule';
import FilingScheduleTable from './FilingScheduleTable';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

interface Props {
    schedule?: FilingSchedule[]
    previousSchedule?: FilingSchedule[]
}


const BallotQuestionCommittee = (props: Props): JSX.Element => {
    return (
        <Box>
            <Typography variant="h6" gutterBottom fontWeight={600}>
                Ballot Question Committees
            </Typography>
            <Typography component={'span'} variant="subtitle1" gutterBottom>
                <b> Statewide Committees </b><Typography component={'span'} variant='subtitle2'>(<i>Questions appearing on a statewide ballot</i>)</Typography>:
            </Typography>
            <Typography variant="body1" component={'p'} gutterBottom>
                All committees organized to support or oppose a question on a state ballot are required to file periodic reports with OCPF in accordance with the following schedule. Before raising and spending fund, click <Link href="https://www.ocpfreporter.us/OnlineOrganization/" target="_blank">here</Link> to organize a Ballot Question Committee.
            </Typography>
            <Accordion defaultExpanded>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography fontWeight={'bold'} variant={'subtitle1'}>Current Filing Schedule</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <FilingScheduleTable schedules={props.schedule || []} bq={true} year={props.schedule && props.schedule[0] ? props.schedule[0].year : new Date().getFullYear()} />
                </AccordionDetails>
            </Accordion>

            <Accordion >
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography fontWeight={'bold'} variant={'subtitle1'}>Previous Filing Schedule</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <FilingScheduleTable schedules={props.previousSchedule || []} bq={true} year={props.previousSchedule && props.previousSchedule[0] ? props.previousSchedule[0].year : new Date().getFullYear()} />
                </AccordionDetails>
            </Accordion>

            <Typography marginTop={5} variant="h6" gutterBottom fontWeight={600}>
                Ballot Question Spending Reports
            </Typography>

            <Typography component={'span'} variant="subtitle1" gutterBottom>
                <b>Form CPF 22</b>
            </Typography>

            <Typography variant="body1" component={'p'} gutterBottom>
                Any corporation, association, organization or other group, other than a political committee organized with OCPF, must e-file the Form CPF 22 if it has given, paid, expended or contributed money or other thing of value in order to support or oppose a ballot question appearing on the ballot at a state election.
                Any individual who makes an expenditure of $250 or more to support or oppose a ballot question must also e-file the CPF 22 report.
                Click <Link href="https://ocpf2.blob.core.windows.net/pdf/forms/cpf_22.pdf" target="_blank">here</Link> for the Form CPF 22.
            </Typography>
            <Typography variant="body1" component={'p'} gutterBottom>
                The Form CPF 22 is e-filed on the same schedule as state ballot question committees (above).
            </Typography>
            

            <Typography component={'span'} variant="subtitle1" gutterBottom marginTop={2}>
                <b>Form CPF 22A</b>
            </Typography>
            <Typography variant="body1" component={'p'} gutterBottom>
                The Form CPF 22A is filed by governmental entities that use public funds or resources to affect the vote on a ballot question.
                Generally, the use of public resources for political purposes is prohibited.
                Click <Link href="https://ocpf2.blob.core.windows.net/pdf/forms/cpf_22a.pdf" target="_blank">here</Link> for the Form CPF 22A.
            </Typography>
        </Box>


    )
};

export default BallotQuestionCommittee;